import { makeStyles } from '@material-ui/core/styles';

import { COLOR } from 'assets/styles/colors';

export const VARIANT_STYLES = Object.freeze({
  warning: COLOR.YELLOW_1,
  error: COLOR.RED_2,
  success: COLOR.GREEN_3,
  info: COLOR.WHITE_1,
});

export const containerStyles = makeStyles((theme) => ({
  containerRoot: {
    top: 70,
    [theme.breakpoints.up('sm')]: {
      top: 90,
    },
  },
}));

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minWidth: '320px !important',
    [theme.breakpoints.up('sm_2')]: {
      maxWidth: '580px !important',
    },
  },
  card: {
    width: '100%',
  },
  typography: {
    color: COLOR.GREY_1,
    fontSize: '15px',
    fontWeight: '400',
    wordBreak: 'break-word',
    [theme.breakpoints.up('sm_2')]: {
      fontSize: '16px',
      wordBreak: 'initial',
    },
  },
  actionRoot: {
    padding: '8px 8px 8px 16px',
    justifyContent: 'space-between',
  },
  icons: {
    marginLeft: 'auto',
    '& .MuiIconButton-root': {
      color: COLOR.GREY_1,
    },
  },
  expand: {
    padding: '8px 8px',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  collapse: {
    padding: 16,
  },
  checkIcon: {
    fontSize: 20,
    paddingRight: 4,
  },
  button: {
    padding: 0,
    textTransform: 'none',
  },
}));
